module.exports = __webpack_public_path__ + "0c9c8f03f5c11c1571fd7da534a8b7f1.svg";